import {
  Buildings, CreditCard, PiggyBank, Wallet,
} from "@phosphor-icons/react";

export const ACCOUNT_TYPES = {
  main: {
    icon: Wallet,
    label: "Main",
    description: "Your default account for everyday income and spending.",
  },
  secondary: {
    icon: CreditCard,
    label: "Secondary",
    description: "Another everyday account or card.",
  },
  savings: {
    icon: PiggyBank,
    label: "Savings",
    description: "Money you keep aside rather than spend day to day.",
  },
  business: {
    icon: Buildings,
    label: "Business",
    description: "Company or self-employed income and expenses.",
  },
};

const LEGACY_TYPES = {
  checking: ACCOUNT_TYPES.main,
  cash: ACCOUNT_TYPES.secondary,
  investment: ACCOUNT_TYPES.secondary,
};

export const accountTypeMeta = (type) =>
  ACCOUNT_TYPES[type] || LEGACY_TYPES[type] || ACCOUNT_TYPES.secondary;

export const editableAccountType = (type) => {
  if (type === "checking") return "main";
  if (type === "cash" || type === "investment") return "secondary";
  return ACCOUNT_TYPES[type] ? type : "secondary";
};

/**
 * The balance to send when saving an account, or undefined to send none.
 *
 * An empty or zero start leaves a new account's balance to be calculated from
 * the transactions that arrive, imported history included. An existing
 * account's field is prefilled with its balance, so it is only re-anchored
 * when the user actually moved the figure, to the cent.
 */
export function balanceToSave(account, entered) {
  if (entered == null) return undefined;
  if (!account) return entered === 0 ? undefined : entered;
  const moved = entered.toFixed(2) !== Number(account.current_balance || 0).toFixed(2);
  return moved ? entered : undefined;
}
